import { AxiosInstance } from 'axios'
import { toast } from '../../../../../packages/ui/src/components/Sonner'
import { FolderTreeResponse } from '../folder/folder.type'

export class AttachmentApi {
    constructor(private readonly client: AxiosInstance) {}

    async getUrlFilePreview(fileId: string): Promise<string> {
        try {
            const { data } = await this.client.post<{ ticket: string }>(`/attachments/${fileId}/preview-ticket`)
            const baseUrl = this.client.defaults.baseURL || ''
            return `${baseUrl}/attachments/${fileId}/stream?ticket=${data.ticket}`
        } catch (error) {
            console.error('Failed to get preview ticket:', error)
            return ''
        }
    }

    async downloadFile(fileId: string, fileName?: string): Promise<void> {
        try {
            const { data } = await this.client.post<{ ticket: string }>(`/attachments/${fileId}/preview-ticket`)
            const baseUrl = this.client.defaults.baseURL || ''
            const url = `${baseUrl}/attachments/${fileId}/download?ticket=${data.ticket}`

            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', fileName || '')
            link.setAttribute('rel', 'noopener noreferrer')
            link.setAttribute('target', '_blank')
            document.body.appendChild(link)
            link.click()
            link.remove()
        } catch (error: any) {
            this.handleDownloadError(error)
        }
    }

    async getBlobFilePreview(fileId: string): Promise<Blob> {
        const { data } = await this.client.post<{ ticket: string }>(`/attachments/${fileId}/preview-ticket`)
        const baseUrl = this.client.defaults.baseURL || ''
        const url = `${baseUrl}/attachments/${fileId}/stream?ticket=${data.ticket}`

        const response = await this.client.get<Blob>(url, {
            responseType: 'blob',
        })
        return response.data
    }

    async getFolderTree(id: string): Promise<FolderTreeResponse> {
        const response = await this.client.get<FolderTreeResponse>(`/attachments/${id}/tree-folders`)
        return response.data
    }

    private triggerDownload(blob: Blob, fileName: string) {
        const blobUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobUrl
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(blobUrl)
    }

    private handleDownloadError(error: any) {
        toast.error({
            title: error?.response?.data?.message || error?.message || 'Something went wrong.',
        })
    }

    private getFileNameFromHeader(headers: any) {
        const disposition = headers['content-disposition']
        if (!disposition) return null

        const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i)
        if (utf8Match?.[1]) {
            try {
                return decodeURIComponent(utf8Match[1])
            } catch {
                return utf8Match[1]
            }
        }

        const asciiMatch = disposition.match(/filename="?([^";]+)"?/i)
        if (!asciiMatch?.[1]) return null

        try {
            return decodeURIComponent(asciiMatch[1])
        } catch {
            return asciiMatch[1]
        }
    }
}
